import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { ICulture } from 'src/app/xena-api/dtos';
import { IQueryStringFilter, defaultListOptionsFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class CultureService {

  constructor(private xenaClient: XenaClient) {
  }

  list(filter: IQueryStringFilter = defaultListOptionsFilter): Observable<Page<ICulture>> {
    const resourcePath: string = '/Culture';
    return this.xenaClient.list<ICulture, IQueryStringFilter>(resourcePath, filter);
  }

  xenaUICultures(filter: IQueryStringFilter = defaultListOptionsFilter): Observable<Page<ICulture>> {
    const resourcePath: string = '/Culture/Profiles';
    return this.xenaClient.list<ICulture, IQueryStringFilter>(resourcePath, filter);
  }
}
